/**
 * Descuentos POS: modal, aplicar y quitar.
 */

export function attachDiscountsGlobals(win, $) {
	if (!win.descuentoActual) {
		win.descuentoActual = { tipo: 'porcentaje', valor: 0, activo: false };
	}

	win.abrirModalDescuentos = function abrirModalDescuentos() {
		$('#modal-descuentos').css('display', 'flex');
		const d = win.descuentoActual || { activo: false };
		if (d.activo) {
			const tipoTexto =
				d.tipo === 'porcentaje' ? `${d.valor}%` : `$${parseFloat(d.valor || 0).toFixed(2)} USD`;
			$('#descuento-activo-modal').show().find('.descuento-detalle').text(`${tipoTexto} de descuento`);
		} else {
			$('#descuento-activo-modal').hide();
		}
	};

	win.aplicarDescuentoRapido = function aplicarDescuentoRapido(porcentaje) {
		const carrito = win.carrito || [];
		if (!carrito.length) {
			win.mostrarNotificacion('Agrega productos antes de aplicar descuento', 'error');
			return;
		}
		win.descuentoActual = { tipo: 'porcentaje', valor: porcentaje, activo: true };
		$('#descuento-tipo').val('porcentaje');
		$('#descuento-valor').val(porcentaje);
		win.actualizarCarrito();
		win.actualizarBadgesDescuento();
		win.mostrarNotificacion(`Descuento de ${porcentaje}% aplicado`, 'success');
	};

	win.aplicarDescuento = function aplicarDescuento() {
		const tipo = $('#descuento-tipo').val();
		const valor = parseFloat($('#descuento-valor').val());
		if (!valor || valor <= 0) {
			win.mostrarNotificacion('Ingresa un valor válido para el descuento', 'error');
			return;
		}
		if (tipo === 'porcentaje' && valor > 100) {
			win.mostrarNotificacion('El porcentaje no puede ser mayor a 100%', 'error');
			return;
		}
		const carrito = win.carrito || [];
		if (!carrito.length) {
			win.mostrarNotificacion('Agrega productos antes de aplicar descuento', 'error');
			return;
		}
		win.descuentoActual = { tipo, valor, activo: true };
		win.actualizarCarrito();
		win.actualizarBadgesDescuento();
		const tipoTexto = tipo === 'porcentaje' ? `${valor}%` : `$${valor.toFixed(2)} USD`;
		win.mostrarNotificacion(`Descuento de ${tipoTexto} aplicado`, 'success');
	};

	win.quitarDescuento = function quitarDescuento() {
		win.descuentoActual = { tipo: 'porcentaje', valor: 0, activo: false };
		$('#descuento-tipo').val('porcentaje');
		$('#descuento-valor').val('');
		win.actualizarCarrito();
		win.actualizarBadgesDescuento();
		win.mostrarNotificacion('Descuento removido', 'success');
	};
}
